import { render, staticRenderFns } from "./_top_menu.vue?vue&type=template&id=2074ab35&scoped=true&"
import script from "./_top_menu.vue?vue&type=script&lang=js&"
export * from "./_top_menu.vue?vue&type=script&lang=js&"
import style0 from "./_top_menu.vue?vue&type=style&index=0&id=2074ab35&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2074ab35",
  null
  
)

export default component.exports